var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisacard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visa 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24 19.4571C24 20.3092 23.3648 21 22.5813 21H1.41867C0.635156 21.0001 0 20.3092 0 19.4571V4.54289C0 3.69075 0.635156 3 1.41867 3H22.5813C23.3649 3 24 3.6908 24 4.54289V19.4571Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.3269 12.0962L4.76337 9.39291C4.66704 9.02011 4.38673 8.9092 4.03648 8.89453H1.45283L1.42981 9.01805C3.44211 9.50588 4.77359 10.6827 5.3269 12.0962Z",
    fill: "#F79F1A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.3135 8.94922H9.6441L8.6015 15.0677H10.2681L11.3135 8.94922Z",
    fill: "#059BBF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.34429 15.0613L8.96976 8.95312H7.203L5.56973 13.1263L5.3954 12.4962C5.07525 11.7382 4.16025 10.6472 3.08606 9.96037L4.57903 15.0633L6.34429 15.0613Z",
    fill: "#059BBF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.0749 13.0668C16.0811 12.3721 15.635 11.8423 14.6739 11.4047C14.0898 11.122 13.7338 10.9335 13.7381 10.6467C13.7381 10.3933 14.0396 10.1211 14.6928 10.1211C15.2394 10.1127 15.633 10.232 15.9408 10.3556L16.0916 10.4247L16.3179 9.09927C15.987 8.97566 15.4697 8.84375 14.8228 8.84375C13.1748 8.84375 12.0148 9.67302 12.0043 10.8624C11.9938 11.7419 12.8336 12.2319 13.4659 12.525C14.115 12.8238 14.3328 13.015 14.3286 13.283C14.3244 13.6928 13.8113 13.8797 13.3318 13.8797C12.6639 13.8797 12.31 13.7876 11.7611 13.559L11.5478 13.461L11.3135 14.832C11.7027 15.0021 12.423 15.1508 13.1706 15.157C14.9231 15.157 16.0623 14.3383 16.0749 13.0668Z",
    fill: "#059BBF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M18.0578 14.1482C18.2484 14.1482 19.9507 14.1503 20.1937 14.1503C20.244 14.3633 20.3968 15.0674 20.3968 15.0674H21.9442L20.5936 8.95312H19.3059C18.9059 8.95312 18.6086 9.06202 18.4327 9.4598L15.9556 15.0674H17.7083C17.7082 15.0674 17.9929 14.3137 18.0578 14.1482ZM19.2011 11.1852C19.1928 11.202 19.3393 10.8314 19.4231 10.601L19.5361 11.1286C19.5361 11.1286 19.8545 12.5903 19.9214 12.896H18.5373C18.6755 12.5443 19.2011 11.1852 19.2011 11.1852Z",
    fill: "#059BBF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M22.5813 3H1.41867C0.635156 3 0 3.63516 0 4.41872V5.89116H24V4.41872C24 3.63516 23.3649 3 22.5813 3Z",
    fill: "#059BBF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M22.5813 20.8912H1.41867C0.635156 20.8912 0 20.256 0 19.4724V18H24V19.4724C24 20.256 23.3649 20.8912 22.5813 20.8912Z",
    fill: "#F79F1A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.15,
    d: "M1.00861 19.457V4.54288C1.00861 3.69074 1.64381 3 2.42738 3H1.41862C0.635156 3 0 3.69074 0 4.54288V19.4571C0 20.3092 0.635156 21 1.41867 21H2.42742C1.64386 21 1.00861 20.3092 1.00861 19.457Z",
    fill: "#202121"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisacard);
export default __webpack_public_path__ + "static/media/visacard.cbcdf699f9012e8abfab6301f1acc945.svg";
export { ForwardRef as ReactComponent };